import { useQuery } from "@tanstack/react-query";

import { getPracticeLandUseChanges, getPracticeLandUseChangesAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_LAND_USE_CHANGES } from "consts";

export const useGetLandUseChanges = () => {
  const isAdmin = getEnvironment().admin;
  const queryFn = isAdmin ? getPracticeLandUseChangesAdmin : getPracticeLandUseChanges;
  return useQuery({
    queryKey: [FOOTPRINTING_LAND_USE_CHANGES],
    queryFn: () => queryFn(),
  });
};
